<template>
    <div class="main_empty">
        <div class="shadow"
             v-show="isShow"
             @click="toHide()"></div>
        <div class="footer"
             :class="{ footer_bot: paddingBottom,footer_new: noJson }"
             v-show="isShow">
            <p class="title"
               v-if="noJson">支付会员</p>

            <!-- vip购买弹窗 -->
            <div class="box"
                 v-if="!noJson">
                <p class="pay_way">
          <span class="line"
                :class="{ line_orange: isColor, pay_btn_blue: isBlue }"></span>{{ isBlue ? "选择风险报告" : "选择VIP" }}
                    <span class="close_btn"
                          @click="toHide()"></span>
                </p>
                <div class="vip_box"
                     v-if="!isBlue">
                    <div class="list"
                         v-for="(item, index) in vipList"
                         :key="index"
                         :class="{
              act: index == isActList && !isBlue,
              act_blue: index == isActList && isBlue,
            }"
                         @click="checkList(index, item)">
                        <p class="title1">
                            {{
                            item.vipOption
                            }}<span v-if="item.isRecommend == '1'"
                                    class="recommend"
                                    :class="{ recommend_blue: isBlue }"></span>
                        </p>
                        <p class="vip_li"
                           v-for="(itm, idx) in item.content.split(';')"
                           :key="idx">
              <span v-for="(im, ix) in itm.split(':')"
                    :key="ix"
                    :class="{
                  linerGrad: index == isActList && !isBlue,
                  color3: ix == 1,
                  linerGradBlue: index == isActList && isBlue,
                }">{{ im }}</span>
                        </p>
                        <p class="sell">
                            <span class="sellOnly">仅售</span>
                            <span class="sellMoney"><span class="lineThrough">￥{{ item.originalPrice }} </span>
                <span class="oriMoney"
                      :class="{
                    oriAct: index == isActList && !isBlue,
                    oriActBlue: index == isActList && isBlue,
                  }">￥{{ item.price }}</span></span>
                        </p>
                    </div>
                </div>
                <div class="vip_box"
                     v-else>
                    <div class="list"
                         v-for="(item, index) in blackList"
                         :key="index"
                         :class="{ act_blue: index == isActBlackList && isBlue }"
                         @click="checkList1(index, item)">
                        <p class="title1">
                            {{
                            item.title
                            }}<span v-if="item.hasRecommend == '1'"
                                    class="recommend"
                                    :class="{ recommend_blue: isBlue }"></span>
                        </p>
                        <div class="li_box">
                            <p class="vip_li"
                               v-for="(itm, idx) in item.content.split(';')"
                               :key="idx">
                <span v-for="(im, ix) in itm.split(':')"
                      :key="ix"
                      :class="{ linerGradBlue: index == isActBlackList && isBlue }">{{ im }}</span>
                            </p>
                        </div>

                        <p class="sell">
                            <span class="sellOnly">仅售</span>
                            <span class="sellMoney"><span class="lineThrough">￥{{ item.originalPrice }} </span>
                <span class="oriMoney"
                      :class="{ oriActBlue: index == isActBlackList && isBlue }">￥{{ item.price }}</span></span>
                        </p>
                    </div>
                </div>
                <p class="pay_way">
          <span class="line"
                :class="{ line_orange: isColor, pay_btn_blue: isBlue }"></span>请选择支付方式
                </p>
                <div class="">
                    <div class="pay_box">
                        <div class="pay_item"
                             v-for="(item, index) in payList"
                             :key="index"
                             @click="checkPay(index, item)"
                             :class="{
                pay_act_blue: isActive == index && isBlue,
                pay_act: isActive == index && !isBlue,
              }">
                            <span class="he" v-if="item.id == 1" :class="'icon_wx'"></span>
                            <span class="he" v-if="item.id == 2" :class="'icon_alp'"></span>
                            <span class="he" v-if="item.id == 3" :class="'icon_bank'"></span>
                            {{ item.title }}
                            <span :class="{
                  act_icon_blue: isActive == index && isBlue,
                  act_icon: isActive == index && !isBlue,
                }"></span>
                        </div>
                    </div>
                </div>
                <p class="remark"
                   v-if="buyEntrance == 2"
                   @click="toArgeement">
                    确认支付即代表您同意《个人报告查询授权书》
                </p>
                <p class="remark"
                   v-else
                   @click="toArgeement">
                    确认支付即代表您同意《会员服务协议》
                </p>
            </div>

            <div class="pd"
                 v-if="noJson">
                <div class="item"
                     v-for="(item, index) in payList"
                     :key="index"
                     @click="checkPay(index, item)">
                    <!--          <span :class="index ? 'icon_alp' : 'icon_wx'"></span>-->
                    <span v-if="item.id === 1" :class="'icon_wx'"></span>
                    <span v-if="item.id === 2" :class="'icon_alp'"></span>
                    <span v-if="item.id === 3" :class="'icon_bank'"></span>
                    <div class="center">
                        <p class="pay_title">{{ item.title }}</p>
                        <p class="pay_con">{{ item.con }}</p>
                    </div>
                    <div class="ite_uncheck"
                         :class="{ ite_check: isActive == index }"></div>
                </div>
                <p class="remark"
                   v-if="buyEntrance == 2"
                   @click="toArgeement">
                    确认支付即代表您同意《数据检测授权协议》
                </p>
                <p class="remark"
                   v-else
                   @click="toArgeement">
                    确认支付即代表您同意《会员服务协议》
                </p>
            </div>
            <div class="pay_btn"
                 :class="{ pay_btn_orange: isColor, pay_btn_blue: isBlue }"
                 @click="toPay">
                确认支付{{ currentPayMoney }}元
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            "isShow",
            "blackList",
            "isColor",
            "isBlue",
            "payMoney",
            "scenceCode",
            "noJson",
            "productId",
            "memberTypeId",
            "orderId",
            "eventKey",
            "buyEntrance",
            "toastXy",
        ],
        data() {
            return {
                isActive: "0",
                payList: [
                    {
                        title: "支付宝",
                        con: "推荐已开通支付宝支付的用户使用",
                        id: 2,
                        page: 36,
                    },
                    {
                        title: "银行卡支付",
                        con: "推荐已开通银行卡支付的用户使用",
                        id: 3,
                        page: 37,
                    },
                    {
                        title: '微信支付',
                        con: '推荐支付方式',
                        id: 1,
                        page: 35,
                    },
                    {
                        title: "支付宝支付",
                        con: "推荐已开通支付宝支付的用户使用",
                        id: 2,
                        page: 38,
                    },
                ],
                // payList1: [
                //   {
                //     title: "支付宝",
                //     con: "推荐已开通支付宝支付的用户使用",
                //     id: 2,
                //     page: 36,
                //   },
                //   {
                //     title: '微信支付',
                //     con: '推荐支付方式',
                //     id: 1,
                //     page: 35,
                //   },
                // ],
                vipList: [],
                isActList: "",
                isActBlackList: "",
                currentPayWay: "36",
                currentPayMoney: "",
                currentMemberTypeId: "",
                appVersion: localStorage.getItem("appVersion"),
                paddingBottom: false,
            };
        },
        created() {
            let p = localStorage.getItem("os");
            if (p == 1) {
                this.paddingBottom = false;
            } else if (p == 2) {
                this.paddingBottom = this.$route.query.paddingBottom;
            }
            this.getPayWay();
        },
        mounted() {
            if (!this.noJson && !this.isBlue) {
                //不是黑名单
                this.getMemberInfo();
            } else {
                this.currentPayMoney = this.payMoney;
            }
            this.appVersion = localStorage.getItem("appVersion");
            // if (parseFloat(this.appVersion) < parseFloat('1.3.0')) {
            //   //隐藏微信
            //   this.payList.pop();
            //   this.payList1.pop();
            // }
        },
        watch: {
            memberTypeId: {
                handler(newValue, oldValue) {
                    //父组件param对象改变会触发此函数
                    this.currentMemberTypeId = newValue;
                },
                deep: true,
            },
            payMoney: {
                handler(newValue, oldValue) {
                    //父组件param对象改变会触发此函数
                    this.currentPayMoney = newValue;
                },
                deep: true,
            },
            blackList: {
                handler(newValue, oldValue) {
                    let _this = this;
                    //父组件param对象改变会触发此函数
                    _this.blackList = newValue;
                    _this.blackList.filter(function (item, index) {
                        if (item.hasDefault == 1) {
                            _this.currentPayMoney = item.price;
                            _this.currentMemberTypeId = item.type;
                            _this.isActBlackList = index;
                        }
                    });
                },
                deep: true,
            },
        },
        methods: {
            getMemberInfo() {
                let _this = this;
                let param = {
                    scenceCode: "0",
                };
                this.$get("/app/v1.0/memeber/memberTypeInfo", param)
                    .then((res) => {
                        if (res.code == 200) {
                            _this.vipList = res.data;
                            _this.vipList.filter(function (item, index) {
                                // if (item.isRecommend == 1) {
                                //   _this.currentPayMoney = item.price;
                                //   _this.currentMemberTypeId = item.memberTypeId;
                                // }
                                if (item.isDefault == 1) {
                                    _this.currentPayMoney = item.price;
                                    _this.currentMemberTypeId = item.memberTypeId;
                                    _this.isActList = index;
                                }
                            });
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            //统计埋点
            toCountPoint(payType) {
                //payType:1微信，2支付宝
                let param = {
                    event_key: this.eventKey,
                    vip_type: this.currentMemberTypeId,
                    scene_code: this.scenceCode,
                    pay_type: payType,
                };
                this.$get("/app/api/v1/newEventTrace", param)
                    .then((res) => {
                        if (res.code == 200) {
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            //跳转客户端
            toPay() {
                console.log(this.currentPayWay)
                let json = {
                    productId: this.productId,
                    memberOrderSource: "1",
                    scenceCode: this.scenceCode,
                    memberType: this.currentMemberTypeId,
                    payMoney: this.currentPayMoney,
                    orderId: this.orderId,
                    buyEntrance: this.buyEntrance, //1:会员，2：黑名单
                };
                if (this.currentPayMoney.toString().slice(0, 1) == "￥") {
                    json.payMoney = json.payMoney.slice(1);
                }
                if (this.currentPayWay == 36) {  //0: 支付宝 1:微信
                    json.payType = 0;
                } else {
                    json.payType = 1;
                }
                if (this.currentPayWay == 36) {
                    this.$get("/app/v1.0/pay/paySelect")
                        .then((res) => {
                            if (res.code == 200) {
                                let result = res.data;
                                if (result == 1) {
                                    try {
                                        window.webkit.messageHandlers.toYsePay.postMessage(json); //ios
                                    } catch (err) {
                                        window.AppJs.toYsePay(JSON.stringify(json)); //android
                                    }
                                } else {
                                    try {
                                        window.webkit.messageHandlers.toAliPay.postMessage(json); //ios
                                    } catch (err) {
                                        window.AppJs.toAliPay(JSON.stringify(json)); //android
                                    }
                                }
                            } else {
                                this.util.toast({msg: res.message});
                            }
                        })
                        .catch((error) => {
                        });
                } else if (this.currentPayWay == 35) {
                    //微信支付
                    if (this.eventKey) {
                        this.toCountPoint(1); //去埋点
                    }
                    try {
                        window.webkit.messageHandlers.toWexinPay.postMessage(json); //ios
                    } catch (err) {
                        window.AppJs.toWexinPay(JSON.stringify(json)); //android
                    }
                } else if (this.currentPayWay == 37) {
                    //银行卡支付
                    let param = {
                        memberType: this.currentMemberTypeId,
                        customerId: localStorage.getItem("customerId")
                            ? localStorage.getItem("customerId")
                            : "",
                        productId: this.productId,
                        memberOrderSource: "1",
                        price: typeof this.currentPayMoney === 'string' ? this.currentPayMoney.replace("￥", "") : this.currentPayMoney,
                        buyEntrance: this.buyEntrance, //1:会员，2：黑名单,
                        source: 2,
                    };
                    this.$post("/app/v1.0/memeber/submitMember2", param)
                        .then(res => {
                            if (res.code == 200) {
                                console.log("执行到这里...")
                                console.log(res.data)
                                var data = res.data;
                                console.log(data)
                                this.$router.push({
                                    path: "/afterLoan/bankInfo",
                                    query: {
                                        prepaid: data.id,
                                        scenceCode: this.scenceCode
                                    },
                                });
                            } else {
                                this.util.toast({msg: res.message});
                            }
                        }).catch(err => {
                    })
                } else if (this.currentPayWay == 38) {
                    let param = {
                        memberType: this.currentMemberTypeId,
                        customerId: localStorage.getItem("customerId")
                            ? localStorage.getItem("customerId")
                            : "",
                        productId: this.productId,
                        memberOrderSource: "1",
                        price: typeof this.currentPayMoney === 'string' ? this.currentPayMoney.replace("￥", "") : this.currentPayMoney,
                        buyEntrance: this.buyEntrance, //1:会员，2：黑名单,
                        source: 0,
                    };
                    this.$post("/app/v1.0/memeber/submitMember2", param)
                        .then(res => {
                            if (res.code == 200) {
                                console.log("执行到这里...")
                                console.log(res.data)
                                var data = res.data;
                                console.log(data)
                                let attachJson = {
                                    productId: this.productId,
                                    buyEntrance: this.buyEntrance
                                };
                                let payParam = {
                                    out_trade_no: data.memberOrder,
                                    attach: JSON.stringify(attachJson)
                                };
                                this.$post('/app/v1.0/pay/h5Alipay', payParam)
                                    .then(res => {
                                        var e = res;
                                        if (e.code == 200) {
                                            console.log(e.data)

                                            const div = document.createElement("div");
                                            div.innerHTML = e.data;
                                            document.body.appendChild(div);
                                            document.forms[0].submit();
                                        } else {
                                            _this.util.toast({msg: e.message})
                                        }
                                    })
                                    .catch(error => {
                                    });
                            } else {
                                this.util.toast({msg: res.message});
                            }
                        }).catch(err => {
                    })
                }
            },
            toHide() {
                this.$parent.isShow = false;
                this.currentPayWay = "36";
                this.isActive = "0";
                let _this = this;
                this.vipList.filter(function (item, index) {
                    if (item.isDefault == 1) {
                        _this.isActList = index;
                        _this.currentPayMoney = item.price;
                        _this.currentMemberTypeId = item.memberTypeId;
                    }
                });
            },
            checkPay(index, item) {
                this.currentPayWay = item.page;
                this.isActive = index;
            },
            //vip里面的切换
            checkPay1(index) {
                this.isActive = !this.isActive;
            },
            checkList(index, item) {
                this.isActList = index;
                this.currentPayMoney = item.price;
                this.currentMemberTypeId = item.memberTypeId;
            },
            checkList1(index, item) {
                this.isActBlackList = index;
                this.currentPayMoney = item.price;
                this.currentMemberTypeId = item.type;
            },
            toArgeement() {
                if (this.buyEntrance == 2) {
                    window.location.href =
                        // "http://thread.yanhugame.com/agreement%2F%E4%B8%AA%E4%BA%BA%E6%8A%A5%E5%91%8A%E6%9F%A5%E8%AF%A2%E6%8E%88%E6%9D%83%E4%B9%A6.pdf";
                        "https://thread.yanhugame.com/agreement/个人报告授权书.html"
                } else {
                    // this.$router.push({
                    //   path: "/vip/agreement",
                    // });
                    window.location.href = "https://thread.yanhugame.com/agreement/会员服务协议.html"
                }
            }, getPayWay() {
                this.$get('/app/api/v1/config/getValue?key=member_pay_way')
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            var result = []
                            this.payList.forEach(m => {
                                if (e.data.includes(m.id)) {
                                    result.push(m);
                                }
                            })
                            if ("com.tcb.TCHelp" == localStorage.getItem("packageName")) {
                                this.payList = result.filter(item => item.page != 36)
                                this.currentPayWay=this.payList[0].page;
                            } else {
                                this.payList = result.filter(item => item.page != 38)
                                this.currentPayWay=this.payList[0].page;
                            }
                        console.log(this.payList+"   "+this.currentPayWay)
                        } else {
                            this.util.toast({msg: "支付方式配置不存在"})
                        }
                    })
                    .catch(error => {
                    });
            },
        },


    };
</script>
<style scoped>
    .main_empty {
        width: 100%;
        height: 100%;
    }

    .shadow {
        /* position: absolute; */
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 1);
        opacity: 0.4;
        z-index: 11;
    }

    .color3 {
        color: #333;
    }

    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        background: #fff;
        z-index: 111;
        width: 100%;
    }

    .footer_new {
        /*height: 50%;*/
    }

    .footer_bot {
        bottom: 0.7rem;
    }

    .footer .title {
        /* color: #c6a47e; */
        color: #333;
        font-size: 0.18rem;
        border-bottom: 1px solid #eeeeee;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
        padding: 0.1rem;
        margin-bottom: 0.12rem;
    }

    .footer .pay_way,
    .footer .pay_way1 {
        margin-left: 0.05rem;
        color: #999;
        font-size: 0.14rem;
        font-weight: bold;
        position: relative;
        padding-top: 0.1rem;
    }

    .footer .pay_way1 {
        color: #999;
        font-size: 0.14rem;
    }

    .pay_way .line {
        width: 0.03rem;
        height: 0.12rem;
        background: #5175f1;
        display: inline-block;
        margin-right: 0.1rem;
    }

    .footer .remark {
        color: #c6a47e;
        font-size: 0.12rem;
        margin-bottom: 0.2rem;
    }

    .pd {
        padding: 0 0.15rem;
    }

    .footer .item {
        border-bottom: 1px solid #eee;
        margin-bottom: 0.15rem;
        /* margin-top: 0.15rem; */
        padding-bottom: 0.15rem;
        display: flex;
        flex: 1;
        position: relative;
    }

    /*.footer .icon_wx,*/
    .footer .icon_alp {
        background: url('../assets/img/vip/handle_alp_icon.png') no-repeat center center;
        background-size: 100%;
        width: 0.4rem;
        height: 0.4rem;
        display: inline-block;
        margin-right: 0.1rem;
        position: relative;
        top: 0.04rem;
    }

    .footer .icon_bank {
        background: url('../assets/img/vip/handle_bank_icon.png') no-repeat center center;
        background-size: 100%;
        width: 0.4rem;
        height: 0.4rem;
        display: inline-block;
        margin-right: 0.1rem;
        position: relative;
        top: 0.04rem;
    }

    .footer .icon_wx {
        background: url('../assets/img/vip/handle_wex_icon.png') no-repeat center center;
        background-size: 100%;
        width: 0.4rem;
        height: 0.4rem;
        display: inline-block;
        margin-right: 0.1rem;
        position: relative;
        top: 0.04rem;
    }

    .footer .ite_check,
    .footer .ite_uncheck,
    .footer .ite_check_green {
        background: url('../assets/img/vip/handle_uncheck.png') no-repeat center center;
        background-size: 100%;
        width: 0.16rem;
        height: 0.16rem;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 0.15rem;
    }

    .footer .ite_check {
        background: url('../assets/img/vip/handle_checked.png') no-repeat center center;
        background-size: 100%;
    }

    .footer .ite_check_green {
        background: url('../assets/img/vip/choice_check.png') no-repeat center center;
        background-size: 100%;
    }

    .footer .pay_title {
        color: #333333;
        font-size: 0.14rem;
        position: relative;
        top: 0.03rem;
        margin-bottom: 0.06rem;
    }

    .footer .pay_con {
        color: #999999;
        font-size: 0.12rem;
    }

    .pay_btn {
        color: #ffffff;
        font-size: 0.17rem;
        text-align: center;
        background: linear-gradient(
                90deg,
                rgba(122, 157, 246, 1) 0%,
                rgba(81, 117, 241, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 25px;
        height: 0.5rem;
        line-height: 0.5rem;
        width: 90%;
        margin: 0 auto;
        margin-bottom: 0.7rem;
    }

    .pay_btn_orange {
        background: linear-gradient(
                135deg,
                rgba(255, 172, 85, 1) 0%,
                rgba(255, 57, 31, 1) 100%
        );
        box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
        border-radius: 39px;
    }

    .pay_way .line_orange {
        background: linear-gradient(
                135deg,
                rgba(255, 172, 85, 1) 0%,
                rgba(255, 57, 31, 1) 100%
        );
    }

    .pay_way .pay_btn_blue {
        background: linear-gradient(
                90deg,
                rgba(122, 157, 246, 1) 0%,
                rgba(81, 117, 241, 1) 100%
        );
    }

    .pay_btn_green {
        background: linear-gradient(
                90deg,
                rgba(80, 199, 150, 1) 0%,
                rgba(96, 200, 157, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
    }

    .vip_box {
        display: flex;
        flex: 1;
        justify-content: space-around;
        padding: 0.1rem 0;
    }

    .vip_box .list {
        flex: 1;
        padding: 0.1rem;
        font-size: 0.12rem;
        padding-bottom: 0;
        border: 1px solid #f9f9f9;
        background: #f9f9f9;
        border-radius: 4px;
    }

    .vip_box .act {
        border: 1px solid #ff8756;

        background: rgba(255, 228, 228, 0.24);
    }

    .vip_box .act_blue {
        border: 1px solid #4374f8;
        color: rgba(49, 137, 245, 1);
        background: rgba(228, 241, 255, 0.24);
    }

    .vip_box .list:first-child {
        margin-right: 0.1rem;
    }

    .vip_li,
    .sell {
        display: flex;
        flex: 1;
        justify-content: space-between;
        margin-bottom: 0.1rem;
        font-size: 0.12rem;
        color: #666;
    }

    .vip_li:last-child {
        margin-bottom: 0;
    }

    .sellMoney {
        font-size: 0.12rem;
        color: #ccc;
    }

    .oriMoney {
        /* color: #999; */
        font-size: 0.24rem;
        color: #333;
        background: none;
        -webkit-text-fill-color: #333;
    }

    .oriAct {
        background: linear-gradient(
                135deg,
                rgba(255, 172, 85, 1) 0%,
                rgba(255, 57, 31, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-decoration: line-through;
    }

    .oriActBlue {
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-decoration: line-through;
    }

    .linerGrad {
        background: linear-gradient(
                135deg,
                rgba(255, 172, 85, 1) 0%,
                rgba(255, 57, 31, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .linerGradBlue {
        color: #3189f5;
    }

    .limit {
        margin-bottom: 0.06rem;
    }

    .vip_box .list .title1 {
        font-size: 0.17rem;
        font-weight: bold;
        margin-bottom: 0.1rem;
        position: relative;
    }

    .recommend {
        /* font-size: 0.12rem;
        border: 1px solid #ccc;
        padding: 0 3px;
        color: #666;
        font-weight: normal;
        position: relative;
        top: -0.01rem; */
        display: inline-block;
        width: 0.39rem;
        height: 0.17rem;
        background: url('../assets/img/vip/recomm_icon.png') no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        right: -0.18rem;
    }

    .recommend_blue {
        background: url('../assets/img/vip/recomm_icon_blue.png') no-repeat center center;
        background-size: 100% 100%;
    }

    .pay_box {
        display: flex;
        flex: 1;
        /* justify-content: space-around; */
    }

    .pay_item {
        width: 1.2rem;
        height: 0.5rem;
        text-align: center;
        line-height: 0.5rem;
        border: 1px solid #f5f5f5;
        margin-right: 0.1rem;
        margin-bottom: 0.08rem;
        margin-top: 0.1rem;
        border-radius: 4px;
        position: relative;
    }

    .pay_act {
        border: 1px solid rgba(255, 135, 86, 1);
    }

    .pay_act_blue {
        border: 1px solid #4374f8;
    }

    .footer .he {
        height: 0.2rem;
        width: 0.2rem;
        position: relative;
        top: 0.06rem;
    }

    .lineThrough {
        text-decoration: line-through;
    }

    .sellOnly {
        position: relative;
        top: 0.1rem;
        color: #999;
        font-size: 0.12rem;
    }

    .box {
        padding: 0.09rem;
    }

    .act_icon,
    .act_icon_blue {
        display: inline-block;
        width: 0.19rem;
        height: 0.19rem;
        background: url('../assets/img/vip/act_icon.png') no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
    }

    .act_icon_blue {
        background: url('../assets/img/vip/act_icon_blue.png') no-repeat center center;
        background-size: 100% 100%;
    }

    .close_btn {
        display: inline-block;
        width: 0.16rem;
        height: 0.16rem;
        background: url('../assets/img/vip/close_btn.png') no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        top: 0.11rem;
    }

    .jiantou_icon {
        display: inline-block;
        width: 0.06rem;
        height: 0.13rem;
        background: url('../assets/img/vip/jiantou.png') no-repeat center center;
        background-size: 100% 100%;
        position: relative;
        top: 0.03rem;
        margin-left: 0.03rem;
    }

    .li_box {
        min-height: 1.3rem;
    }
</style>
